import { Loader } from '@googlemaps/js-api-loader'
import { apiKeys } from './settings'

const loader = new Loader({
  apiKey: apiKeys.google,
  libraries: ['places'],
})

export const googleMapsReady: Promise<typeof google> = loader.load()
